import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { formatCurrency } from '../calculator-utils';

import styles from './styles.module.scss';
const {
  chart_container,
  chart_wrapper,
  center_amount,
  center_subtitle,
  legend_container,
  legend_item,
  legend_color,
  legend_label,
  legend_amount,
  condensed,
  hide_visual,
  mobile_total
} = styles;

const PaymentChart = ({
  data,
  centerLabel = 'per month',
  showLegend = true,
  condensed: condensedProp = false,
  hideVisual: hideVisualProp = false
}) => {
  const COLORS = {
    'Principal & Interest': '#E56667',
    Taxes: '#333333',
    Insurance: '#808080',
    'Mortgage Insurance': '#DC2626'
  };

  const chartData = data.filter((item) => item.value > 0);
  const total = chartData.reduce((sum, item) => sum + item.value, 0);

  const chartSize = condensedProp ? 200 : 300;
  const innerRadius = condensedProp ? 60 : 80;
  const outerRadius = condensedProp ? 100 : 130;

  const renderCustomLabel = () => {
    return (
      <g>
        <text
          x="50%"
          y="50%"
          textAnchor="middle"
          dominantBaseline="middle"
          className={center_amount}
        >
          {formatCurrency(total)}
        </text>
        <text
          x="50%"
          y="60%"
          textAnchor="middle"
          dominantBaseline="middle"
          className={center_subtitle}
        >
          {centerLabel}
        </text>
      </g>
    );
  };

  const containerClasses = classNames(chart_container, {
    [condensed]: condensedProp,
    [hide_visual]: hideVisualProp
  });
  const wrapperClasses = classNames(chart_wrapper, {
    [condensed]: condensedProp
  });
  const legendClasses = classNames(legend_container, {
    [condensed]: condensedProp
  });

  return (
    <div className={containerClasses}>
      <div className={wrapperClasses}>
        <ResponsiveContainer width="100%" height={chartSize}>
          <PieChart>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              innerRadius={innerRadius}
              outerRadius={outerRadius}
              paddingAngle={4}
              dataKey="value"
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[entry.name] || '#8884d8'} />
              ))}
            </Pie>
            {renderCustomLabel()}
          </PieChart>
        </ResponsiveContainer>
      </div>

      {hideVisualProp && (
        <div className={mobile_total}>
          <div className={center_amount}>{formatCurrency(total)}</div>
          <div className={center_subtitle}>{centerLabel}</div>
        </div>
      )}

      {showLegend && (
        <div className={legendClasses}>
          {chartData.map((entry) => (
            <div key={entry.name} className={legend_item}>
              <div className={legend_label}>
                <div
                  className={legend_color}
                  style={{ backgroundColor: COLORS[entry.name] || '#8884d8' }}
                />
                {entry.name.toUpperCase()}
              </div>
              <div className={legend_amount}>{formatCurrency(entry.value)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

PaymentChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired
    })
  ).isRequired,
  centerLabel: PropTypes.string,
  showLegend: PropTypes.bool,
  condensed: PropTypes.bool,
  hideVisual: PropTypes.bool
};

export default PaymentChart;
